export const getMaxEnumValue = (enumObj: { [key: string]: number | string }): number => {
	const values = Object.values(enumObj).filter(value => typeof value === "number");
	return Math.max(...values);
};
